import { Badge } from '@/components/ui/badge'
import { TAG_COLOR_TABLE } from '@/constants/tag-table'
import { AppRoutes } from '@/routes'
import { cn } from '@/utils/cn'
import Image from 'next/image'
import Link from 'next/link'
import { HTMLAttributes } from 'react'
import { usePopularProductList } from './use-popular-product-list'
import { tagNameConverter } from '@/shared/lib/utils/tag-name-converter'
export interface PopularProductListProps {
  productId: string
}

// TODO: UI 분리
export const PopularProductList = ({
  className,
  productId,
  ...props
}: PopularProductListProps & HTMLAttributes<HTMLDivElement>) => {
  const { data } = usePopularProductList(productId)

  if (!data) {
    return null
  }
  return (
    <div className={cn(className)} {...props}>
      <div className="mb-5 mt-2">
        <h2 className="text-heading-02-bold">유사한 상품을 추천드려요</h2>
      </div>

      <div className="grid grid-cols-2 gap-[10px] sm:grid-cols-3 lg:grid-cols-4">
        {data.results.map(({ id, imageUrl, title, price, tags }) => {
          return (
            <Link
              key={id}
              href={AppRoutes.product(id)}
              //   id={tagId.nav(SECTION.POPULARS)(PAGE.PRODUCT_DETAIL, id)}
            >
              <div className="relative flex size-full flex-col">
                <div className="relative mb-[17px] aspect-square overflow-hidden rounded-[6px] border border-gray-2 md:mb-[8px]">
                  <Image fill src={imageUrl} alt="" unoptimized />
                </div>
                <span className="text-caption-01-semi">{title}</span>
                <div className="my-[8px] text-body-02-bold sm:text-heading-02-bold">
                  <span className="text-point-red">{price.diffRate}%</span>
                  <span className="text-[#171717]">
                    {price.price.toLocaleString()}원
                  </span>
                </div>
                <div className="flex gap-1 pb-[8px]">
                  {tags
                    .filter((tag) => tag.isVisible)
                    .map((tag, index) => (
                      <Badge
                        variant={TAG_COLOR_TABLE[tag.code]}
                        key={index}
                        className="line-clamp-1 rounded-[4px] px-1.5 text-[10px]"
                      >
                        {tagNameConverter(tag.name)}
                      </Badge>
                    ))}
                </div>
              </div>
            </Link>
          )
        })}
      </div>
    </div>
  )
}
